import { resolveIAiGeneratedBrowserPublicServiceBaseUrl } from "@airange/shared/platform-urls";

function readEnv(key: string) {
  const value = typeof process !== "undefined" ? process.env?.[key] : undefined;
  return typeof value === "string" ? value.trim().replace(/\/+$/, "") : "";
}

function currentHostname() {
  return typeof window !== "undefined" ? window.location.hostname : undefined;
}

function resolveGeneratedPublicServiceUrl(service: "micro-lab-admin" | "micro-lab-portal", message: string) {
  try {
    return resolveIAiGeneratedBrowserPublicServiceBaseUrl(service, {
      readClientEnv: readEnv,
      hostname: currentHostname(),
    });
  } catch (error) {
    if (error instanceof Error && error.message.startsWith("Cannot resolve ")) {
      throw new Error(message);
    }
    throw error;
  }
}

export const MICRO_LAB_API_BASE_URL = `${resolveGeneratedPublicServiceUrl(
  "micro-lab-admin",
  "Micro lab admin API base URL requires explicit env or a browser host that resolves the Micro Lab admin service",
)}/api`;

export function resolveMicroLabApiEndpoint(path: `/api/${string}`) {
  return `${MICRO_LAB_API_BASE_URL}${path.slice("/api".length)}`;
}

export const PORTAL_BASE_URL = resolveGeneratedPublicServiceUrl(
  "micro-lab-portal",
  "Micro lab admin portal base URL requires explicit env or a browser host that resolves the Micro Lab portal service",
);
